import { render, staticRenderFns } from "./RealFriendMeetingPostDetailPage.vue?vue&type=template&id=422f64f2&scoped=true"
import script from "./RealFriendMeetingPostDetailPage.vue?vue&type=script&lang=js"
export * from "./RealFriendMeetingPostDetailPage.vue?vue&type=script&lang=js"
import style0 from "./RealFriendMeetingPostDetailPage.vue?vue&type=style&index=0&id=422f64f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "422f64f2",
  null
  
)

export default component.exports